import {
  Snackbar,
  useTheme,
  IconButton,
  Box,
  Slide,
  Tooltip,
  SlideProps,
} from '@mui/material'
import { useState } from 'react'
import { ClientUpdateNotification } from '../../types/models/ClientUpdateNotification'
import { CheckListIcon } from '../../icons/CheckListIcon'

export const ClientUpdateNotificationSnackbar = ({
  notification,
  onClose,
}: {
  notification: ClientUpdateNotification
  onClose: () => void
}) => {
  const [isOpen, setIsOpen] = useState(true)
  const theme = useTheme()

  const handleClose = () => {
    setIsOpen(false)
    onClose()
  }

  const handleDetailClick = (e: React.MouseEvent) => {
    e.stopPropagation() // ボタンクリック時にSnackbar全体のクリックを防ぐ
    if (notification.detailUrl) {
      window.open(notification.detailUrl, '_blank')
    }
  }

  const handleConfirmClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    handleClose()
  }

  const SlideTransition = (props: SlideProps) => {
    return <Slide {...props} direction="left" />
  }

  const getPriorityStyle = () => {
    switch (notification.priority) {
      case 'high':
        return {
          backgroundColor: 'white',
          color: theme.palette.warning.main,
          borderColor: theme.palette.warning.main,
        }
      case 'medium':
        return {
          backgroundColor: 'white',
          color: theme.palette.primary.dark,
          borderColor: theme.palette.primary.dark,
        }
      case 'low':
      default:
        return {
          backgroundColor: 'white',
          color: theme.palette.secondary.dark,
          borderColor: theme.palette.secondary.dark,
        }
    }
  }

  const priorityStyle = getPriorityStyle()

  return (
    <Snackbar
      style={{
        zIndex: 1302,
        bottom: '20px',
        right: '100px',
        left: 'auto',
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={isOpen}
      autoHideDuration={null}
      onClose={undefined}
      TransitionComponent={SlideTransition}
    >
      <Box
        sx={{
          backgroundColor: priorityStyle.backgroundColor,
          color: priorityStyle.color,
          border: `2px solid ${priorityStyle.borderColor}`,
          borderRadius: 1,
          padding: 1.5,
          minWidth: 280,
          maxWidth: 400,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Tooltip title="確認したのでもう表示しない" arrow placement="top">
            <IconButton
              size="small"
              onClick={handleConfirmClick}
              sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.1)',
                },
                width: 24,
                height: 24,
                flexShrink: 0,
              }}
            >
              <CheckListIcon sx={{ fontSize: '14px' }} />
            </IconButton>
          </Tooltip>
          <Box
            sx={{
              flex: 1,
              fontSize: '14px',
              lineHeight: 1.4,
              wordBreak: 'break-word',
            }}
          >
            {notification.message}
            {notification.detailUrl && (
              <Box
                component="span"
                onClick={handleDetailClick}
                sx={{
                  ml: 1,
                  color: priorityStyle.color,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8,
                  },
                }}
              >
                詳細はこちら
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Snackbar>
  )
}
